import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-azul/15 bg-ink" data-id="element-67" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" data-id="element-68" data-mp="3gh3s4gzgmag7">
        <p className="font-display text-xl font-bold uppercase text-white" data-id="element-69" data-mp="32pfeg99kbdx4">
          NEURO-RUNNING PACK<span className="align-super text-xs" data-id="element-70" data-mp="36q900vzj8gmu">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-71" data-mp="3ueim7z0nr6ei">
          El sistema de psicología deportiva N°1 para corredores que quieren ganarle a su mente.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm italic leading-relaxed text-plata" data-id="element-72" data-mp="3levgx24t5gg6">
          “Porque entrenar el cuerpo se hace en la calle sumando kilómetros, pero la cabeza es igual
          o más importante que las piernas.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-73" data-mp="29xm1qrsppako">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-azul-soft" data-id="element-74" data-mp="2ew6z8jgkxg5f">
            <MailIcon className="h-4 w-4 text-plata" data-id="element-75" data-mp="3gcjywzp6sgl4" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-azul-soft" data-id="element-76" data-mp="3v916dfu99b2e">
            <InstagramIcon className="h-4 w-4 text-plata" data-id="element-77" data-mp="81ywcgswhu2x" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-azul-soft" data-id="element-78" data-mp="34p834h8zogo">
            <GlobeIcon className="h-4 w-4 text-plata" data-id="element-79" data-mp="huo8ldw9zbzb" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-6 font-display text-base font-semibold text-naranja-soft" data-id="element-80" data-mp="qthyymj0j64f">
          🔍 “Entrená la mente. Dominá el asfalto.” 🛡️
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-81" data-mp="mt7vphmlutt9">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white/70" data-id="element-82" data-mp="twfs04aigfx6">
            Términos y condiciones
          </a>
          <span data-id="element-83" data-mp="13tao6gjba48a">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white/70" data-id="element-84" data-mp="13sr7121hjjvb">
            Política de privacidad
          </a>
          <span data-id="element-85" data-mp="18lbw5q9g58si">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white/70" data-id="element-86" data-mp="18ltx30720b6r">
            Soporte
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-87" data-mp="1hjnukegk1avi">
          © 2026 NEURO-RUNNING PACK™ — SIGMA SMART™ — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}